
/* injects from baggage-loader */

import React from 'react';
import { t } from '../../../../helpers/translator';
import moment from "moment";
import PropTypes from 'prop-types';

class SportResults extends React.Component {
    render() {
        const { sportComps, filteredData, isFiltred } = this.props;
        return (
            <div>
                {
                    sportComps && sportComps.length > 0
                        ? <div className="container-info">
                            <div className="container-info-header">
                                <div className="title-bg">
                                    <div className="inner-info-header">
                                        <div>{t(`DATE`)}</div>
                                        <div>{t(`ID `)}</div>
                                        <div>{t(`SPORT`)}</div>
                                        <div>{t(`MATCH`)}</div>
                                        <div>{t(`COMPETITION`)}</div>
                                        <div>{t(`REGION`)}</div>
                                    </div>
                                </div>
                            </div>
                            {
                                !isFiltred
                                    ? sportComps.map((item) => {
                                        if (!item.scores) {
                                            item.scores = ""; //quick fix
                                        }
                                        if (item.scores.length > 0 || !item.scores.includes("Void") || item.scores !== "") {
                                            var matchedScore = item.scores.match(/(\d*:\d*)/g);
                                        } else {
                                            var firstResultError = item.scores;
                                        }
                                        if (matchedScore !== null) {
                                            let finalResult = matchedScore[0].split(":");
                                            var firstScoreResult = finalResult[0];
                                            var secondScoreResult = finalResult[1];
                                        } else {
                                            if (item.scores !== "") {
                                                var errorResult = item.scores;
                                            } else {
                                                var secondResultError = "Void";
                                            }
                                        }
                                        // console.log(errorResult, firstResultError, '====================SCORE');
                                        // eslint-disable-next-line react/jsx-key
                                        return <div className="match-info" key={item.game_id}>
                                            <div className="inner-match-info open-info" >
                                                <div className="match-row">
                                                    <div className="item-match">{moment.unix(item.date).format('lll')}</div>
                                                    <div className="item-match">{item.short_id}</div>
                                                    <div className="item-match">{item.sport_name}</div>
                                                    <div className="item-match">
                                                        <div className="teams">
                                                            <div className="first-name">{item.team1_name}</div>
                                                            {errorResult || firstResultError || secondResultError ? <div></div> : firstScoreResult === secondScoreResult
                                                                ? <div className="count-team"><span>{firstScoreResult} </span>:<span> {secondScoreResult}</span> </div> :
                                                                firstScoreResult > secondScoreResult
                                                                    ? <div className="count-team"><span className="active">{firstScoreResult} </span>:<span> {secondScoreResult}</span> </div>
                                                                    : <div className="count-team"><span>{firstScoreResult} </span>:<span className="active"> {secondScoreResult}</span></div>}
                                                            <div className="last-name">{item.team2_name}</div>
                                                        </div>
                                                    </div>
                                                    <div className="item-match">{item.competition_name}</div>
                                                    <div className="item-match">{item.region_name}
                                                        { //<div className="icon-block"></div>
                                                        }
                                                    </div>
                                                </div>
                                                {/* <div className="statistics">
                                                        <div className="inner-statistics">
                                                            <div className="match-row">
                                                                <div className="item-statistics">
                                                                    <div className="inside-item">
                                                                        <span className="inside-item-info">corner</span>
                                                                        <p className="count-data">
                                                                            <span className="sp-d"></span>
                                                                            <span></span>
                                                                        </p>
                                                                    </div>
                                                                    <div className="inside-item">
                                                                        <span className="inside-item-info">yellow card</span>
                                                                        <p className="count-data">
                                                                            <span className="sp-d"></span>
                                                                            <span></span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="item-statistics">
                                                                    <div className="inside-item">
                                                                        <span className="inside-item-info">accumlator outcomes</span>
                                                                        <p className="count-data">
                                                                            <span className="sp-d"></span>
                                                                            <span></span>
                                                                        </p>
                                                                    </div>
                                                                    <div className="inside-item">
                                                                        <span className="inside-item-info">shots on target</span>
                                                                        <p className="count-data">
                                                                            <span className="sp-d"></span>
                                                                            <span></span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="item-statistics">
                                                                    <div className="inside-item">
                                                                        <span className="inside-item-info">goal kiks</span>
                                                                        <p className="count-data">
                                                                            <span className="sp-d"></span>
                                                                            <span></span>
                                                                        </p>
                                                                    </div>
                                                                    <div className="inside-item">
                                                                        <span className="inside-item-info">throw-ins</span>
                                                                        <p className="count-data">
                                                                            <span className="sp-d"></span>
                                                                            <span></span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="item-statistics">
                                                                    <div className="inside-item">
                                                                        <span className="inside-item-info">fouls</span>
                                                                        <p className="count-data">
                                                                            <span className="sp-d"></span>
                                                                            <span></span>
                                                                        </p>
                                                                    </div>
                                                                    <div className="inside-item">
                                                                        <span className="inside-item-info">posts and crossbars</span>
                                                                        <p className="count-data">
                                                                            <span className="sp-d"></span>
                                                                            <span></span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="item-statistics">
                                                                    <div className="inside-item">
                                                                        <span className="inside-item-info">ball possession</span>
                                                                    </div>
                                                                    <div className="inside-item">
                                                                        <span className="inside-item-info">first to happen</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                            </div>
                                        </div>;
                                    })
                                    : filteredData && isFiltred && filteredData.map((item) => {
                                        if (!item.scores) {
                                            item.scores = ""; //quick fix
                                        }
                                        if (item.scores.length > 0 || !item.scores.includes("Void") || item.scores !== "") {
                                            var matchedScore = item.scores.match(/(\d*:\d*)/g);
                                        } else {
                                            var firstResultError = item.scores;
                                        }
                                        if (matchedScore !== null) {
                                            let finalResult = matchedScore[0].split(":");
                                            var firstScoreResult = finalResult[0];
                                            var secondScoreResult = finalResult[1];
                                        } else {
                                            if (item.scores !== "") {
                                                var errorResult = item.scores;
                                            } else {
                                                var secondResultError = "Void";
                                            }
                                        }
                                        // eslint-disable-next-line react/jsx-key
                                        return <div className="match-info" key={item.game_id}>
                                            <div className="inner-match-info open-info" >
                                                <div className="match-row">
                                                    <div className="item-match">{moment.unix(item.date).format('lll')}</div>
                                                    <div className="item-match">{item.short_id}</div>
                                                    <div className="item-match">{item.sport_name}</div>
                                                    <div className="item-match">
                                                        <div className="teams">
                                                            <div className="first-name">{item.team1_name}</div>
                                                            {errorResult || firstResultError || secondResultError ? <div></div> : firstScoreResult === secondScoreResult
                                                                ? <div className="count-team"><span>{firstScoreResult} </span>:<span> {secondScoreResult}</span> </div> :
                                                                firstScoreResult > secondScoreResult
                                                                    ? <div className="count-team"><span className="active">{firstScoreResult} </span>:<span> {secondScoreResult}</span> </div>
                                                                    : <div className="count-team"><span>{firstScoreResult} </span>:<span className="active"> {secondScoreResult}</span></div>}
                                                            <div className="last-name">{item.team2_name}</div>
                                                        </div>
                                                    </div>
                                                    <div className="item-match">{item.competition_name}</div>

                                                    <div className="item-match">{item.region_name}
                                                        {//   <div className="icon-block"></div>
                                                        }
                                                    </div>

                                                </div>
                                            </div>
                                        </div>;
                                    })
                            }
                        </div>
                        : null
                }
            </div>
        );
    }
}
SportResults.propTypes = {
    sportComps: PropTypes.array,
    filteredData: PropTypes.array,
    isFiltred: PropTypes.bool
};
export default SportResults;